import { Directive, ElementRef, Input, OnInit, SimpleChanges, OnChanges, OnDestroy, Renderer2 } from '@angular/core';
import { annotate } from "rough-notation";

export type NcTypeType = 'underline' | 'box' | 'circle' | 'highlight' | 'strike-through' | 'crossed-off' | 'bracket';
export type NcBracketType = 'left' | 'right' | 'top' | 'bottom';

@Directive({
  selector: '[ncHighlighter]'
})
export class HighlighterDirective implements OnInit, OnChanges, OnDestroy {
  /** 荧光笔类型 */
  @Input() ncType: NcTypeType = 'highlight';
  /** 是否开启动画效果 */
  private _animate: boolean = true;
  @Input()
  set ncAnimate(val: boolean | string) {
    this._animate = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncAnimate(): boolean {
    return this._animate;
  }
  /** 动画持续时间，单位ms */
  @Input() ncAnimationDuration: number = 800;
  /** 荧光笔颜色 */
  @Input() ncColor: string = "#ffd1dc";
  /** 荧光笔宽度，单位px */
  @Input() ncStrokeWidth: number = 1.5;
  /** 荧光笔内边距，单位px */
  @Input() ncPadding: number | [number, number] | [number, number, number, number] = 2;
  /** 动画迭代次数 */
  @Input() ncIterations: number = 2;
  /** 括号类型，仅当ncType为bracket时有效 */
  @Input() ncBrackets: NcBracketType | NcBracketType[] = ['left', 'right'];
  /** 动画默认从左往右绘制，若要从右往左绘制请设置成true */
  private _rtl: boolean = false;
  @Input()
  set ncRtl(val: boolean | string) {
    this._rtl = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncRtl(): boolean {
    return this._rtl;
  }
  /** 可手动切换该值来显示或隐藏荧光笔 */
  private _enabled: boolean = true;
  @Input()
  set ncEnabled(val: boolean | string) {
    this._enabled = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncEnabled(): boolean {
    return this._enabled;
  }

  private annotation: any;
  private isInitialized: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.create();
    this.isInitialized = true;
    if (this.ncEnabled) {
      this.show();
    }
  }

  ngOnDestroy() {
    if (this.annotation) {
      this.annotation.remove();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isInitialized) {
      if (changes['ncType']) {
        this.annotation.type = this.ncType;
      }
      if (changes['ncAnimate']) {
        this.annotation.animate = this.ncAnimate;
      }
      if (changes['ncAnimationDuration']) {
        this.annotation.animationDuration = this.ncAnimationDuration;
      }
      if (changes['ncColor']) {
        this.annotation.color = this.ncColor;
      }
      if (changes['ncStrokeWidth']) {
        this.annotation.strokeWidth = this.ncStrokeWidth;
      }
      if (changes['ncPadding']) {
        this.annotation.padding = this.ncPadding;
      }
      if (changes['ncIterations']) {
        this.annotation.iterations = this.ncIterations;
      }
      if (changes['ncBrackets']) {
        this.annotation.brackets = this.ncBrackets;
      }
      if (changes['ncRtl']) {
        this.annotation.rtl = this.ncRtl;
      }
      if (changes['ncEnabled']) {
        if (this.ncEnabled) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }

  create() {
    //svg会生成在宿主的同级。这里设置宿主的父级为相对定位。使svg相对于宿主父级定位，防止svg在向上查找定位父级时出现一些不可控的问题
    const elementPosition = getComputedStyle(this.el.nativeElement.parentElement).position;
    if (!elementPosition || elementPosition === 'static') {
      this.renderer.setStyle(this.el.nativeElement.parentElement, 'position', 'relative');
    }

    this.annotation = annotate(this.el.nativeElement, {
      type: this.ncType,
      animate: this.ncAnimate,
      animationDuration: this.ncAnimationDuration,
      color: this.ncColor,
      strokeWidth: this.ncStrokeWidth,
      padding: this.ncPadding,
      iterations: this.ncIterations,
      brackets: this.ncBrackets,
      rtl: this.ncRtl,
    });
  }

  show() {
    this.annotation.show();
  }

  hide() {
    this.annotation.hide();
  }
}